import { createReducer } from "@reduxjs/toolkit";

import {
  packageFailure,
  packageRequest,
  packagesFailure,
  packagesRequest,
  packagesSuccess,
  packageSuccess,
  paymentFailure,
  paymentRequest,
  paymentSuccess,
  paymentReset
} from "./packagesActions";
import { Package } from "../types";

export type PackageState = {
  loading: boolean;
  error?: string;
  items: Package[];
  total?: number;
  currentPackage?: Package;
  currentLoading: boolean;
  currentError?: string;
  paymentLoading: boolean;
  paymentError?: string;
  paymentSuccess?: boolean;
  payment?: {
    checkoutUrl?: string;
    depositId?: string;
    package?: any;
    provider?: string;
    transactionId?: string;
    newBalance?: number;
    isEpayForm?: boolean;
  };
};

const initialState: PackageState = {
  loading: false,
  items: [],
  total: 0,
  currentLoading: false,
  paymentLoading: false,
};

export const packageReducer = createReducer(initialState, (b) => {
  b.addCase(packagesRequest, (s) => {
    s.loading = true;
    s.error = undefined;
  });

  b.addCase(packagesSuccess, (s, a) => {
    s.loading = false;
    s.items = a.payload.items;
    s.total = a.payload.total;
  });

  b.addCase(packagesFailure, (s, a) => {
    s.loading = false;
    s.error = a.payload;
  });

  // Single package
  b.addCase(packageRequest, (s) => {
    s.currentLoading = true;
    s.currentError = undefined;
  });

  b.addCase(packageSuccess, (s, a) => {
    s.currentLoading = false;
    s.currentPackage = a.payload;
  });

  b.addCase(packageFailure, (s, a) => {
    s.currentLoading = false;
    s.currentError = a.payload;
  });

  b.addCase(paymentRequest, (s) => {
    s.paymentLoading = true;
    s.paymentError = undefined;
    s.paymentSuccess = false;
    s.payment = undefined; 
  });

 b.addCase(paymentSuccess, (s, a) => {
    s.paymentLoading = false;
    s.paymentSuccess = true;
    s.payment = {
      checkoutUrl: a.payload.checkoutUrl,
      depositId: a.payload.depositId,
      package: a.payload.package,
      provider: a.payload.provider,
      transactionId: a.payload.transactionId,
      newBalance: a.payload.newBalance,
      isEpayForm: a.payload.isEpayForm,
    };
  });

   b.addCase(paymentFailure, (s, a) => {
    s.paymentLoading = false;
    s.paymentError = a.payload;
    s.payment = undefined;
  });

  b.addCase(paymentReset, (s) => {
  s.paymentLoading = false;
  s.paymentError = undefined;
  s.paymentSuccess = false;
  s.payment = undefined; 
});
});
